export default {
    data() {
        return {
            
        }
    },
    
    methods: {
        setElementByIDSrc(id, src) {
            const element = document.getElementById(id)
            if (element) {
                element.src = src
                if(this.wdm.wdmdebug) console.log('set:'+id+' ('+src+')')
            } else {
                if(this.wdm.wdmdebug) console.log(id+' - Element not found! ('+src+')')
            }

        },
        moneyFormat(value) {
            const sprog = navigator.language
            return String(Intl.NumberFormat(sprog, { style: 'currency', currency: 'DKK' }).format(value)) 
        },
      
        dynamicSort:function(property) {
            var sortOrder = 1;
            if(property[0] === "-") {
                sortOrder = -1;
                property = property.substr(1);
                
            }
            return function (a,b) {
                   
                var result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;

                if (a[property] === null) { result = 1   }
                if (b[property] === null) { result = -1  }                   
                    
                   
                    return (result * sortOrder)
                }
        },
        async wdmFetch(url, type, bodyObject) {
            
            const headers = { "Authorization" : 'Bearer '+this.wdm.token };
            
            const options = { 
                method: type == null ? "GET" : type,
                headers: headers, 
            };
            if (type != 'GET') options['body']=JSON.stringify(bodyObject)
            //if ('DEVTESTLocal'.includes(this.wdm.system)) console.log(options)
            const res = await fetch('/api/'+url, options)
            return res
        },
        fetchError(res) {
            if (res.status==401) {
                alert('Dit login er udløbet, venligst login igen')
              } else {
                alert('Noget gik galt, vi prøver at hente siden igen...('+String(res.status)+')')
                window.location.reload()
              }
        },
        getDate(date) {
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            month = (month < 10 ? "0" : "") + month;
            var day = date.getDate();
            day = (day < 10 ? "0" : "") + day;
            return year + "-" + month + "-" + day;
            },           

            getLocalDateTime(timestamp) {

                const date = new Date(timestamp)
    
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                month = (month < 10 ? "0" : "") + month;
                var day = date.getDate();
                day = (day < 10 ? "0" : "") + day;
                
                var hours =   date.getHours()
                var minutes = date.getMinutes()
                var seconds = date.getSeconds()
                minutes = (minutes < 10 ? "0" : "") + minutes;
                seconds = (seconds < 10 ? "0" : "") + seconds;
                return {'date': year + "-" + month + "-" + day, time:hours + ":" + minutes + ":" + seconds}
                
            },
    }
}